<template>
  <div class="mappingmaster-auth">
    <div class="panel panel-status">
      <div class="panel-body">
        <div class="mappingmaster-auth-title h1">{{ $t('passwordEmail.sentHeading') }}</div>
        <p class="mappingmaster-auth-title-description">{{ $t('passwordEmail.sentTo') }}</p>
        <div class="mb-0 mappingmaster-main-font-color h3">{{ email }}</div>
      </div>
      <div class="panel-footer">
        <p class="m-0">{{ $t('emailChange.sentTip') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
  import authMixin from '@/helpers/authMixin';

  export default {
    name: 'ChangePasswordSent',
    mixins: [authMixin],
    data() {
      return {
        email: this.$route.query.email,
      };
    },
  };
</script>
